var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubscription(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 8H15C14.4375 8 14 8.46875 14 9V19C14 19.5625 14.4375 20 15 20H21C21.5312 20 22 19.5625 22 19V9C22 8.46875 21.5312 8 21 8ZM21 19H15V9H21V19ZM5 5H17V7H18V5C18 4.46875 17.5312 4 17 4H5C4.4375 4 4 4.46875 4 5V13H2.5C2.21875 13 2 13.25 2 13.5V14C2 15.125 2.875 16 3.96875 16H13V15H3.96875C3.4375 15 3 14.5625 3 14H13V13H5V5Z",
    fill: "#495057"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubscription);
export default __webpack_public_path__ + "static/media/subscription.337965ae.svg";
export { ForwardRef as ReactComponent };